// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const UnderlineOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 448 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M16 56c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-24v144c0 61.9 50.1 112 112 112s112-50.1 112-112V80h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24h-24v144c0 88.4-71.6 160-160 160S64 312.4 64 224V80H40c-13.3 0-24-10.7-24-24zM0 456c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"}}]},"name":"underline","theme":"outlined"};

const UnderlineOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={UnderlineOutlinedSvg} />;
  UnderlineOutlined.displayName = 'UnderlineOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(UnderlineOutlined);
